var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 1",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.37 4.66V2H8.48v2.66H2.75v1.43h1.72L5.69 22h12.52l1.23-15.91h1.95V4.66zM14 3.41v1.22h-4V3.41zM7 20.54L5.88 6.07H18l-1.15 14.47z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.21 8.13h1.43v10.42h-1.43zm4.07 10.46l-1.43-.08.56-10.42 1.43.08zm-6.71 0L8 8.17l1.43-.08.57 10.42z"
})));

export default SvgIconDelete;